import React from 'react'
import { Typography } from 'antd'
import Drawer from 'components/Drawer'
import PlacementIcon from '../icons/TPORequestsIcons/DrawerIcon/PlacementIcon'
import CandidateIcon from '../icons/TPORequestsIcons/DrawerIcon/CandidateIcon'
import TimeClockIcon from '../icons/TPORequestsIcons/DrawerIcon/TimeClockIcon'
import TicketIcon from '../icons/TPORequestsIcons/DrawerIcon/TicketIcon'
import CompletedIcon from '../icons/TPORequestsIcons/DrawerIcon/RoundsCardIcon/CompletedIcon'
import PendingIcon from '../icons/TPORequestsIcons/DrawerIcon/RoundsCardIcon/PendingIcon'
import {
  BorderBoxTag,
  CompanyName,
  ContainarCardContant,
  IconContainar,
  IconContainer,
  IconGroup,
  RoleCard,
  RoleDetails,
  RoleHeader,
  RoleTitle,
  RoundCard,
  RoundCardContainer,
  RoundCardIconContainar,
  ShapeTag,
  TextAlign,
  JobText,
  getOrderBasedColor,
} from './Style'
import { toCamelCase } from '../../utils/helpers'

const { Text } = Typography

const renderIcon = status => {
  switch (status) {
    case 'SHORTLIST':
      return (
        <RoundCardIconContainar status={status}>
          <CompletedIcon style={{ color: 'green' }} />
        </RoundCardIconContainar>
      )
    case 'ABSENT':
      return (
        <RoundCardIconContainar status={status}>
          <PendingIcon style={{ color: 'red' }} />
        </RoundCardIconContainar>
      )

    default:
      return null
  }
}

const InterviewRounds = ({ interviewWorkFlow, driveRoleCandidateMap }) => {
  const rounds = interviewWorkFlow?.rounds || driveRoleCandidateMap
  return (
    <RoundCardContainer roundsLength={rounds?.length}>
      {rounds?.map((round, index) => (
        <RoundCard key={index} status={round.status}>
          <IconContainer>{renderIcon(round.status)}</IconContainer>
          <div style={{ textAlign: 'left' }}>
            <div style={{ color: 'rgb(36, 46, 57)' }}>Round {index + 1}</div>
            <p
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                color: 'rgb(36, 46, 57)',
              }}
            >
              {interviewWorkFlow?.rounds ? round?.name : round?.stage}
            </p>
          </div>
        </RoundCard>
      ))}
    </RoundCardContainer>
  )
}

const ConsentReasonDrawer = ({
  onClose,
  consentReasonDrawer,
  rolesData,
  consentData,
  requestList,
  amountCount,
}) => {
  // LPA Calculation

  function formatCurrency(amount, keyData) {
    if (amount < 100000) {
      return `${(amount / 1000).toFixed(2)}K ${keyData}`
    } else {
      return `${(amount / 100000).toFixed(2)} L${keyData}`
    }
  }

  const content = () => (
    <div>
      <div style={{ marginTop: '16px' }}>
        {consentData?.data?.offerList && consentData?.data?.offerCount > 0 && (
          <TextAlign>
            <Text>
              Showing&nbsp; "{' '}
              {amountCount?.placementType == 'OFFER_ACCEPTED'
                ? 'Offer Accepted'
                : 'Intent to Offer'}
              " &nbsp; from &nbsp;
              <Text strong>{consentData?.data?.offerCount}&nbsp; roles</Text>
            </Text>
          </TextAlign>
        )}

        {consentData?.data?.offerList?.map(offer => (
          <div key={offer.id}>
            <RoleCard>
              <ContainarCardContant>
                <RoleHeader>
                  <div>
                    <RoleTitle>{toCamelCase(offer?.role?.tittle)}</RoleTitle>
                    <CompanyName>
                      {offer?.role?.rolePublishedBy == 'CORPORATE'
                        ? toCamelCase(offer?.role?.corporate?.name)
                        : toCamelCase(offer?.role?.company?.companyName)}
                    </CompanyName>
                  </div>
                </RoleHeader>
                <div>
                  <IconGroup>
                    <PlacementIcon />
                    <Text>
                      {offer?.role?.jobCategory == 'PLACEMENT'
                        ? 'Placement'
                        : ''}
                    </Text>
                    <CandidateIcon />
                    <Text>
                      {offer?.role?.jobTypeLevels == 'ENTRY'
                        ? 'Freshers'
                        : `Exp. (${offer?.role?.yearOfExperience[1]} yrs)`}
                    </Text>
                    <TimeClockIcon />
                    <Text>
                      {offer?.role?.jobType === 'PART_TIME'
                        ? 'Part Time'
                        : offer?.role?.jobType === 'FULL_TIME'
                        ? 'Full Time'
                        : ''}
                    </Text>
                  </IconGroup>

                  <RoleDetails>
                    {(() => {
                      const orderNo = offer?.compRange?.orderNo
                      const colors = getOrderBasedColor(orderNo)

                      return (
                        <BorderBoxTag orderNo={orderNo}>
                          <IconContainar>
                            <TicketIcon color={colors.borderColor} />
                            CTC -&nbsp;
                            {`₹ ${formatCurrency(
                              Number(offer?.role?.maxCompensation),
                              offer?.role?.CTCPeriod === 'MONTHLY' ? 'PM' : 'PA'
                            )}`}
                          </IconContainar>
                          {offer?.compRange ? (
                            <ShapeTag orderNo={orderNo}>
                              {offer?.compRange?.name}{' '}
                            </ShapeTag>
                          ) : null}
                        </BorderBoxTag>
                      )
                    })()}
                  </RoleDetails>
                </div>
              </ContainarCardContant>
            </RoleCard>
          </div>
        ))}

        {consentData?.data?.missedList &&
          consentData?.data?.missedList?.count > 0 && (
            <TextAlign>
              <Text>
                Missed initial &nbsp;
                <Text strong>{consentData?.data?.missedList?.count}</Text>{' '}
                &nbsp;
                <b> roles</b>
              </Text>
            </TextAlign>
          )}
        {consentData?.data?.missedList?.result?.map(offer => (
          <div key={offer.id}>
            <RoleCard>
              <ContainarCardContant>
                <RoleHeader>
                  <div>
                    <RoleTitle>{toCamelCase(offer?.tittle)}</RoleTitle>
                    <CompanyName>
                      {offer?.role?.rolePublishedBy == 'CORPORATE'
                        ? toCamelCase(offer?.corporate?.name)
                        : toCamelCase(offer?.companyName)}
                    </CompanyName>
                  </div>
                </RoleHeader>
                <div>
                  <IconGroup>
                    <PlacementIcon />
                    <Text>
                      {offer?.job_category == 'PLACEMENT' ? 'Placement' : ''}
                    </Text>
                    <CandidateIcon />
                    <Text>
                      {offer?.jobTypeLevels == 'ENTRY'
                        ? 'Freshers'
                        : // : offer?.yearOfExperience[1] + ' years'}
                          `Exp. (${offer?.yearOfExperience[1]} yrs)`}
                    </Text>
                    <TimeClockIcon />
                    <Text>
                      {offer?.jobType === 'PART_TIME'
                        ? 'Part Time'
                        : offer?.jobType === 'FULL_TIME'
                        ? 'Full Time'
                        : ''}
                    </Text>
                  </IconGroup>

                  <RoleDetails>
                    {(() => {
                      const orderNo = offer?.compRange?.orderNo
                      const colors = getOrderBasedColor(orderNo)

                      return (
                        <BorderBoxTag orderNo={orderNo}>
                          <IconContainar>
                            <TicketIcon color={colors.borderColor} />
                            CTC -&nbsp;
                            {`₹ ${formatCurrency(
                              Number(offer?.maxCompensation),
                              offer?.CTCPeriod === 'MONTHLY' ? 'PM' : 'PA'
                            )}`}
                          </IconContainar>
                          {offer?.compRange ? (
                            <ShapeTag orderNo={orderNo}>
                              {offer?.compRange?.name}{' '}
                            </ShapeTag>
                          ) : null}
                        </BorderBoxTag>
                      )
                    })()}
                  </RoleDetails>
                </div>
              </ContainarCardContant>
            </RoleCard>
          </div>
        ))}

        {consentData?.data?.absentList &&
          consentData?.data?.absentCount > 0 && (
            <TextAlign>
              <Text>
                Showing &nbsp;
                <Text strong>
                  {consentData?.data?.absentCount}
                  &nbsp; scheduled evaluations &nbsp;
                </Text>
                that were missed
              </Text>
            </TextAlign>
          )}

        {consentData?.data?.absentList?.map(offer => (
          <div key={offer.id}>
            <RoleCard>
              <ContainarCardContant>
                <RoleHeader>
                  <div>
                    <RoleTitle>{toCamelCase(offer?.role?.tittle)}</RoleTitle>
                    <CompanyName>
                      {offer?.role?.rolePublishedBy == 'CORPORATE'
                        ? toCamelCase(offer?.role?.corporate.name)
                        : toCamelCase(offer?.role?.company?.companyName)}
                    </CompanyName>
                  </div>
                </RoleHeader>
                <div>
                  <IconGroup>
                    <PlacementIcon />
                    <JobText>
                      {offer?.role?.jobCategory == 'PLACEMENT'
                        ? 'Placement'
                        : ''}
                    </JobText>
                    <CandidateIcon />
                    <JobText>
                      {offer?.role?.jobTypeLevels == 'ENTRY'
                        ? 'Freshers'
                        : `Exp. (${offer?.role?.yearOfExperience[1]} yrs)`}
                    </JobText>
                    <TimeClockIcon />
                    <JobText>
                      {offer?.role?.jobType === 'PART_TIME'
                        ? 'Part Time'
                        : offer?.role?.jobType === 'FULL_TIME'
                        ? 'Full Time'
                        : ''}
                    </JobText>
                  </IconGroup>

                  <RoleDetails>
                    {(() => {
                      const orderNo = offer?.compRange?.orderNo
                      const colors = getOrderBasedColor(orderNo)

                      return (
                        <BorderBoxTag orderNo={orderNo}>
                          <IconContainar>
                            <TicketIcon color={colors.borderColor} />
                            CTC -&nbsp;
                            {`₹ ${formatCurrency(
                              Number(offer?.role?.maxCompensation),
                              offer?.role?.CTCPeriod === 'MONTHLY' ? 'PM' : 'PA'
                            )}`}
                          </IconContainar>
                          {offer?.compRange ? (
                            <ShapeTag orderNo={orderNo}>
                              {offer?.compRange?.name}{' '}
                            </ShapeTag>
                          ) : null}
                        </BorderBoxTag>
                      )
                    })()}
                  </RoleDetails>
                </div>
              </ContainarCardContant>
            </RoleCard>
            {offer?.role?.rolePublishedBy === 'INSTITUTE' && (
              <InterviewRounds
                interviewWorkFlow={offer?.role?.interviewWorkFlow}
              />
            )}
            {offer?.role?.rolePublishedBy === 'CORPORATE' && (
              <InterviewRounds
                driveRoleCandidateMap={offer?.role?.driveRoleCandidateMap}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  )

  return (
    <Drawer
      width="40%"
      title="Consent Reason"
      placement="right"
      closable={true}
      visible={consentReasonDrawer}
      onClose={onClose}
      content={content()}
    />
  )
}

export default ConsentReasonDrawer
